import { useNavigate } from "react-router-dom";
import { makeLangUrl } from "helpers/makeLangUrl";

// Icons
import GloryLogotype from "assets/icons/glory/logo_big.svg?react";
import BangerLogotype from "assets/icons/banger/logo.svg?react";

// Url
import url from "url/index";

import "./styles.sass";

const StaticPagesHeader = () => {
  const navigate = useNavigate();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  let SelectedLogotype;

  switch (VITE_APP_PROJECT_NAME) {
    case "glory":
      SelectedLogotype = GloryLogotype;
      break;
    case "banger":
      SelectedLogotype = BangerLogotype;
      break;
    default:
      SelectedLogotype = GloryLogotype;
      break;
  }

  const handleClick = () => {
    navigate(makeLangUrl(url.routes.casino.index()));
  };

  return (
    <div className="StaticPagesHeader">
      <div className="StaticPagesHeader__header">
        <div className="StaticPagesHeader__header_content">
          <div className="StaticPagesHeader__header_logo" onClick={handleClick}>
            <SelectedLogotype />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaticPagesHeader;
